import React from "react"
import NextImage from "next/image"
import { productBadge } from "./ProductBadge.css"

export type Props = {
  src: string
  alt: string
}

export const ProductBadge: React.FC<Props> = ({ src, alt }) => {
  if (!src) return null
  return (
    <div className={productBadge}>
      <NextImage src={src} alt={alt} width={200} height={200} />
    </div>
  )
}
